<div class="container">
    <img src="https://leaseforu-assets.s3.us-east-2.amazonaws.com/assets/images/importe.svg"/>
    <span class="importe">{{ importe | currency:'$'}}</span>
</div>